export const ITEM_TYPES = {
	KomplettPcCabinet: "KomplettPcCabinet",
} as const;
